import { apiUrl } from './api.js';

/**
 * URL DE ORIGEN de la imagen de una carta, en casa del proveedor.
 *
 * Hay dos proveedores y no se piden igual:
 *
 *   - TCGdex devuelve una BASE sin extension y hay que añadirle el tamaño
 *     ("…/me05/004" + "/low.webp").
 *   - El respaldo de pokemontcg.io ya es una URL completa a un .png, y no tiene
 *     variantes de tamaño.
 *
 * Concentrar la diferencia aqui evita repetir el `${image}/low.webp` por media
 * aplicacion y olvidarse del respaldo en la mitad de los sitios -- que es
 * exactamente como se colaron los huecos de las energias basicas.
 */
function origen(card, size) {
  if (!card) return null;
  if (card.image) return `${card.image}/${size}.webp`;
  return card.imageFallback ?? null;
}

/**
 * La imagen de una carta, SIEMPRE SERVIDA POR NUESTRA API.
 *
 * Antes esto devolvia la URL del proveedor y el <img> iba directo a
 * assets.tcgdex.net. Se cambio por dos motivos, y el segundo pesa mas:
 *
 * 1. NO DEPENDER DE QUE UN TERCERO ESTE DE PIE. El 28-jul-2026 ese dominio
 *    dejo de responder un rato y las fichas, la hoja de mazo y las caras del
 *    meta salieron vacias. Ni siquiera daban 404: se quedaban en "pending",
 *    o sea que no habia error que capturar ni nada que reintentar. Detras de
 *    la API hay cache en memoria y en disco (server/src/img-cache.js), y el
 *    arte de una carta no cambia nunca, asi que se guarda una vez y ya.
 *
 * 2. PRIVACIDAD. Las banderas se bajaron a local porque enlazarlas de un CDN
 *    ajeno mandaba la IP de quien mira a un tercero en cada visita. Las cartas
 *    hacian lo mismo y son muchisimas mas: entrar en la enciclopedia eran
 *    sesenta peticiones a un tercero con la IP de quien navega. La coherencia
 *    con eso no es opcional, es el contrato.
 *
 * El coste es un salto mas en la primera peticion de cada imagen. A partir de
 * ahi contestan la CDN de delante y el navegador, porque se sirve con
 * `immutable` y un año de cache.
 */
export function cardArt(card, size = 'low') {
  const url = origen(card, size);
  if (!url) return null;
  return apiUrl(`/api/img?u=${encodeURIComponent(url)}`);
}

/**
 * Misma imagen, y hoy exactamente la misma URL.
 *
 * Existia porque `images.pokemontcg.io` NO manda cabeceras CORS: al dibujar sus
 * imagenes en un canvas lo dejaban "manchado" y `toBlob` fallaba, asi que en el
 * PNG del mazo esas cartas salian como rectangulos vacios. Pasando por la API
 * llegan del mismo origen y el canvas queda limpio.
 *
 * Ahora que TODA imagen pasa por la API, este caso lo cubre `cardArt` sola. Se
 * mantiene el nombre porque en el sitio donde se usa (el PNG de la hoja de
 * mazo) dice POR QUE esa llamada no puede saltarse el proxy, y borrarlo
 * invitaria a "simplificarlo" a la URL del proveedor y a resucitar el bug.
 */
export function cardArtForCanvas(card, size = 'high') {
  return cardArt(card, size);
}
